/** Primary + extra categories a product belongs to */
export function getProductCategories(product) {
  if (Array.isArray(product.categories) && product.categories.length) {
    return product.categories;
  }
  return product.category ? [product.category] : [];
}

export function productInCategory(product, categoryIdOrName) {
  if (!categoryIdOrName || categoryIdOrName === 'all') return true;
  const needle = String(categoryIdOrName).toLowerCase().replace(/\s+/g, '-');
  return getProductCategories(product).some((c) => {
    const val = String(c).toLowerCase();
    return val === needle || val.replace(/\s+/g, '-') === needle;
  });
}

export function productInSubcategory(product, subcategorySlug) {
  if (!subcategorySlug) return true;
  const needle = subcategorySlug.toLowerCase().replace(/\s+/g, '-');
  const subs = [
    product.subcategory,
    ...(Array.isArray(product.subcategories) ? product.subcategories : []),
  ].filter(Boolean);
  return subs.some((s) => String(s).toLowerCase().replace(/\s+/g, '-') === needle);
}

export const products = [
  // ── Women (expanded) ──────────────────────────────────────────
  {
    id: '1',
    name: 'Vista Linen Wrap Dress',
    brand: 'My Fashion Deals',
    category: 'Women',
    categories: ['Women'],
    subcategory: 'Dresses',
    subcategories: ['Dresses'],
    price: 118,
    salePrice: 89,
    image: 'https://images.unsplash.com/photo-1595777457583-95e059d581b8?w=500',
    rating: 4.7,
    reviews: 412,
    description: 'Soft washed linen wrap dress with a fluid skirt — day-to-dinner ready.',
    sizes: ['XS', 'S', 'M', 'L', 'XL'],
    colors: [{ name: 'Sand', hex: '#C9B8A0' }, { name: 'Ink', hex: '#12141A' }],
    inStock: true,
    badge: 'SALE',
  },
  {
    id: '2',
    name: 'City Softshell Coat',
    brand: 'Peakline',
    category: 'Women',
    categories: ['Women', 'Activewear'],
    subcategory: 'Outerwear',
    subcategories: ['Outerwear', 'Active'],
    price: 198,
    salePrice: 149,
    image: 'https://images.unsplash.com/photo-1539533018447-63fcce2678e3?w=500',
    rating: 4.6,
    reviews: 287,
    description: 'Weather-ready softshell with sealed zippers and a clean city silhouette.',
    sizes: ['XS', 'S', 'M', 'L', 'XL'],
    colors: [{ name: 'Charcoal', hex: '#2A2F33' }],
    inStock: true,
    badge: 'SALE',
  },
  {
    id: '3',
    name: 'Morning Rib Tank',
    brand: 'Solace',
    category: 'Women',
    categories: ['Women', 'Activewear'],
    subcategory: 'Tops',
    subcategories: ['Tops', 'Active'],
    price: 36,
    image: 'https://images.unsplash.com/photo-1521572163474-6864f9cf17ab?w=500',
    rating: 4.5,
    reviews: 620,
    description: 'Breathable rib tank with a longer hem for layering or solo wear.',
    sizes: ['XS', 'S', 'M', 'L', 'XL'],
    colors: [{ name: 'White', hex: '#FFFFFF' }, { name: 'Black', hex: '#12141A' }],
    inStock: true,
    badge: 'NEW',
  },
  {
    id: '4',
    name: 'High-Rise Straight Denim',
    brand: 'Loomline',
    category: 'Women',
    categories: ['Women'],
    subcategory: 'Pants',
    subcategories: ['Pants', 'Jeans'],
    price: 98,
    salePrice: 74,
    image: 'https://images.unsplash.com/photo-1582418702059-97ebafb35d09?w=500',
    rating: 4.8,
    reviews: 1102,
    description: 'Organic stretch denim with a straight leg and soft break-in.',
    sizes: ['24', '26', '28', '30', '32'],
    colors: [{ name: 'Indigo', hex: '#2C3E6B' }, { name: 'Black', hex: '#111111' }],
    inStock: true,
    badge: 'SALE',
  },
  {
    id: '5',
    name: 'Cloud Merino Crew',
    brand: 'Harbor Knit',
    category: 'Women',
    categories: ['Women'],
    subcategory: 'Knits',
    subcategories: ['Knits'],
    price: 128,
    image: 'https://images.unsplash.com/photo-1576566588028-4147f3842f27?w=500',
    rating: 4.9,
    reviews: 701,
    description: 'Fine-gauge merino crew that regulates temperature year-round.',
    sizes: ['XS', 'S', 'M', 'L', 'XL'],
    colors: [{ name: 'Camel', hex: '#B08968' }, { name: 'Fog', hex: '#9AA8B0' }],
    inStock: true,
    badge: 'BEST SELLER',
  },
  {
    id: 'w6',
    name: 'Satin Utility Blouse',
    brand: 'Solace',
    category: 'Women',
    categories: ['Women'],
    subcategory: 'Tops',
    subcategories: ['Tops'],
    price: 78,
    image: 'https://images.unsplash.com/photo-1509631179647-0177331693ae?w=500',
    rating: 4.6,
    reviews: 334,
    description: 'Matte satin blouse with a clean collar and double-button cuff.',
    sizes: ['XS', 'S', 'M', 'L', 'XL'],
    colors: [{ name: 'Ivory', hex: '#FFF8EC' }, { name: 'Blush', hex: '#E8C4B8' }],
    inStock: true,
  },
  {
    id: 'w7',
    name: 'Wide-Leg Drift Trousers',
    brand: 'My Fashion Deals',
    category: 'Women',
    categories: ['Women'],
    subcategory: 'Pants',
    subcategories: ['Pants'],
    price: 88,
    salePrice: 68,
    image: 'https://images.unsplash.com/photo-1515886657613-9f3515b0c78f?w=500',
    rating: 4.7,
    reviews: 456,
    description: 'Fluid wide-leg trousers with a high rise and soft drape.',
    sizes: ['0', '2', '4', '6', '8', '10', '12'],
    colors: [{ name: 'Stone', hex: '#D4CBBE' }, { name: 'Ink', hex: '#12141A' }],
    inStock: true,
    badge: 'SALE',
  },
  {
    id: 'w8',
    name: 'Midi Slip Skirt',
    brand: 'Solace',
    category: 'Women',
    categories: ['Women'],
    subcategory: 'Dresses',
    subcategories: ['Dresses', 'Pants'],
    price: 72,
    image: 'https://images.unsplash.com/photo-1583496661160-fb5886a0aaaa?w=500',
    rating: 4.5,
    reviews: 289,
    description: 'Bias-cut midi skirt that moves with you — dress up or down.',
    sizes: ['XS', 'S', 'M', 'L'],
    colors: [{ name: 'Black', hex: '#12141A' }, { name: 'Champagne', hex: '#E8DCC8' }],
    inStock: true,
    badge: 'NEW',
  },
  {
    id: 'w9',
    name: 'Cropped Blazer',
    brand: 'My Fashion Deals',
    category: 'Women',
    categories: ['Women'],
    subcategory: 'Outerwear',
    subcategories: ['Outerwear'],
    price: 148,
    image: 'https://images.unsplash.com/photo-1591369822096-ffd140ec948f?w=500',
    rating: 4.6,
    reviews: 512,
    description: 'Structured cropped blazer with soft shoulder pads.',
    sizes: ['XS', 'S', 'M', 'L', 'XL'],
    colors: [{ name: 'Black', hex: '#12141A' }, { name: 'Ivory', hex: '#F5F1E8' }],
    inStock: true,
  },
  {
    id: 'w10',
    name: 'Cashmere Blend Cardigan',
    brand: 'Harbor Knit',
    category: 'Women',
    categories: ['Women'],
    subcategory: 'Knits',
    subcategories: ['Knits'],
    price: 135,
    salePrice: 110,
    image: 'https://images.unsplash.com/photo-1434389677669-e08b4cac3105?w=500',
    rating: 4.8,
    reviews: 388,
    description: 'Open-front cardigan in a featherweight cashmere blend.',
    sizes: ['XS', 'S', 'M', 'L', 'XL'],
    colors: [{ name: 'Oatmeal', hex: '#E5D9C5' }, { name: 'Navy', hex: '#1A303B' }],
    inStock: true,
    badge: 'SALE',
  },
  {
    id: 'w11',
    name: 'Everyday Crossbody',
    brand: 'Loomline',
    category: 'Women',
    categories: ['Women', 'Handbags'],
    subcategory: 'Crossbody',
    subcategories: ['Crossbody'],
    price: 128,
    image: 'https://images.unsplash.com/photo-1548036328-c9fa89d128fa?w=500',
    rating: 4.7,
    reviews: 601,
    description: 'Compact leather crossbody — fits phone, keys, and a slim wallet.',
    sizes: ['One Size'],
    colors: [{ name: 'Black', hex: '#12141A' }, { name: 'Saddle', hex: '#8B5E3C' }],
    inStock: true,
    badge: 'BEST SELLER',
  },
  {
    id: 'w12',
    name: 'Block Heel Sandals',
    brand: 'My Fashion Deals',
    category: 'Women',
    categories: ['Women', 'Shoes'],
    subcategory: 'Sandals',
    subcategories: ['Sandals'],
    price: 88,
    image: 'https://images.unsplash.com/photo-1543163521-1bf539c55dd2?w=500',
    rating: 4.5,
    reviews: 734,
    description: 'Comfortable block heel with adjustable ankle strap.',
    sizes: ['5', '6', '7', '8', '9', '10'],
    colors: [{ name: 'Nude', hex: '#D7CCC8' }, { name: 'Black', hex: '#12141A' }],
    inStock: true,
  },
  {
    id: 'w13',
    name: 'Studio Leggings',
    brand: 'Peakline',
    category: 'Women',
    categories: ['Women', 'Activewear'],
    subcategory: 'Activewear',
    subcategories: ['Activewear', 'Active', 'Pants'],
    price: 58,
    image: 'https://images.unsplash.com/photo-1506629082955-511b1aa77848?w=500',
    rating: 4.8,
    reviews: 1456,
    description: 'Sculpting high-rise leggings with a buttery soft handfeel.',
    sizes: ['XS', 'S', 'M', 'L', 'XL'],
    colors: [{ name: 'Black', hex: '#12141A' }, { name: 'Olive', hex: '#4A5C3A' }],
    inStock: true,
    badge: 'BEST SELLER',
  },
  {
    id: 'w14',
    name: 'Poplin Button Shirt',
    brand: 'Solace',
    category: 'Women',
    categories: ['Women'],
    subcategory: 'Tops',
    subcategories: ['Tops'],
    price: 64,
    image: 'https://images.unsplash.com/photo-1485968579580-b6d095142e6e?w=500',
    rating: 4.4,
    reviews: 267,
    description: 'Crisp cotton poplin shirt with a relaxed boyfriend fit.',
    sizes: ['XS', 'S', 'M', 'L', 'XL'],
    colors: [{ name: 'White', hex: '#FFFFFF' }, { name: 'Sky', hex: '#A8C4D4' }],
    inStock: true,
    badge: 'NEW',
  },
  {
    id: 'w15',
    name: 'Quilted Puffer Vest',
    brand: 'Peakline',
    category: 'Women',
    categories: ['Women', 'Activewear'],
    subcategory: 'Outerwear',
    subcategories: ['Outerwear', 'Active'],
    price: 110,
    salePrice: 88,
    image: 'https://images.unsplash.com/photo-1548625361-78a4afa897b7?w=500',
    rating: 4.6,
    reviews: 401,
    description: 'Packable quilted vest — layer over knits or under coats.',
    sizes: ['XS', 'S', 'M', 'L', 'XL'],
    colors: [{ name: 'Black', hex: '#12141A' }, { name: 'Lime', hex: '#D4F34A' }],
    inStock: true,
    badge: 'SALE',
  },
  {
    id: 'w16',
    name: 'Gold Hoop Earrings',
    brand: 'My Fashion Deals',
    category: 'Women',
    categories: ['Women', 'Jewelry', 'Accessories'],
    subcategory: 'Earrings',
    subcategories: ['Earrings'],
    price: 48,
    image: 'https://images.unsplash.com/photo-1535632066927-ab7c9ab60908?w=500',
    rating: 4.7,
    reviews: 890,
    description: 'Medium gold-tone hoops with a secure snap hinge.',
    sizes: ['25mm', '35mm'],
    colors: [{ name: 'Gold', hex: '#D4F34A' }],
    inStock: true,
  },
  {
    id: 'w17',
    name: 'Canvas Market Tote',
    brand: 'My Fashion Deals',
    category: 'Women',
    categories: ['Women', 'Handbags', 'Accessories'],
    subcategory: 'Totes',
    subcategories: ['Totes'],
    price: 54,
    image: 'https://images.unsplash.com/photo-1590874103328-eac38a683ce7?w=500',
    rating: 4.5,
    reviews: 312,
    description: 'Heavyweight canvas tote with interior pocket and reinforced straps.',
    sizes: ['One Size'],
    colors: [{ name: 'Natural', hex: '#EDE6D9' }, { name: 'Black', hex: '#12141A' }],
    inStock: true,
    badge: 'NEW',
  },
  {
    id: 'w18',
    name: 'Pleated Midi Dress',
    brand: 'Solace',
    category: 'Women',
    categories: ['Women'],
    subcategory: 'Dresses',
    subcategories: ['Dresses'],
    price: 132,
    image: 'https://images.unsplash.com/photo-1572804013309-59a88b7e92f1?w=500',
    rating: 4.8,
    reviews: 445,
    description: 'Sleeveless pleated midi with a soft V-neck and side zip.',
    sizes: ['XS', 'S', 'M', 'L', 'XL'],
    colors: [{ name: 'Black', hex: '#12141A' }, { name: 'Emerald', hex: '#1B5E4A' }],
    inStock: true,
  },
  {
    id: 'w19',
    name: 'Shearling Mini Boots',
    brand: 'Harbor Knit',
    category: 'Women',
    categories: ['Women', 'Shoes'],
    subcategory: 'Boots',
    subcategories: ['Boots'],
    price: 168,
    image: 'https://images.unsplash.com/photo-1608256246200-53e635b5b65f?w=500',
    rating: 4.9,
    reviews: 2100,
    description: 'Genuine shearling lining with a durable rubber outsole.',
    sizes: ['5', '6', '7', '8', '9', '10'],
    colors: [{ name: 'Chestnut', hex: '#8D6E63' }, { name: 'Black', hex: '#12141A' }],
    inStock: true,
    badge: 'BEST SELLER',
  },
  {
    id: 'w20',
    name: 'Leather Belt',
    brand: 'Loomline',
    category: 'Women',
    categories: ['Women', 'Accessories'],
    subcategory: 'Accessories',
    subcategories: ['Accessories'],
    price: 42,
    image: 'https://images.unsplash.com/photo-1475180098004-ca77a66827be?w=500',
    rating: 4.3,
    reviews: 198,
    description: 'Vegetable-tanned leather belt with a solid brass buckle.',
    sizes: ['S', 'M', 'L'],
    colors: [{ name: 'Black', hex: '#12141A' }, { name: 'Saddle', hex: '#8B5E3C' }],
    inStock: true,
  },

  // ── Men (expanded) ────────────────────────────────────────────
  {
    id: '6',
    name: 'Summit Slim Stretch Jeans',
    brand: 'Loomline',
    category: 'Men',
    categories: ['Men'],
    subcategory: 'Denim',
    subcategories: ['Denim', 'Pants'],
    price: 98,
    salePrice: 74,
    image: 'https://images.unsplash.com/photo-1542272604-787c3835535d?w=500',
    rating: 4.7,
    reviews: 842,
    description: 'Performance stretch denim that still looks like rigid jean.',
    sizes: ['28', '30', '32', '34', '36', '38'],
    colors: [{ name: 'Dark Indigo', hex: '#1A2744' }, { name: 'Black', hex: '#111111' }],
    inStock: true,
    badge: 'SALE',
  },
  {
    id: '7',
    name: 'North Oxford Shirt',
    brand: 'My Fashion Deals',
    category: 'Men',
    categories: ['Men'],
    subcategory: 'Shirts',
    subcategories: ['Shirts'],
    price: 72,
    image: 'https://images.unsplash.com/photo-1602810318383-e386cc2a3ccf?w=500',
    rating: 4.5,
    reviews: 567,
    description: 'Crisp oxford cloth with a soft collar roll and rounded hem.',
    sizes: ['S', 'M', 'L', 'XL', 'XXL'],
    colors: [{ name: 'White', hex: '#FFFFFF' }, { name: 'Sky', hex: '#A8C4D4' }],
    inStock: true,
    badge: 'NEW',
  },
  {
    id: '8',
    name: 'Quarry Quilted Bomber',
    brand: 'Peakline',
    category: 'Men',
    categories: ['Men', 'Activewear'],
    subcategory: 'Outerwear',
    subcategories: ['Outerwear', 'Active'],
    price: 188,
    salePrice: 149,
    image: 'https://images.unsplash.com/photo-1551028719-00167b16eac5?w=500',
    rating: 4.6,
    reviews: 401,
    description: 'Packable quilted bomber with a matte finish and secure zip pockets.',
    sizes: ['S', 'M', 'L', 'XL', 'XXL'],
    colors: [{ name: 'Ink', hex: '#12141A' }],
    inStock: true,
    badge: 'SALE',
  },
  {
    id: '9',
    name: 'Shore Chino Shorts',
    brand: 'My Fashion Deals',
    category: 'Men',
    categories: ['Men'],
    subcategory: 'Pants',
    subcategories: ['Pants'],
    price: 54,
    image: 'https://images.unsplash.com/photo-1591195853828-11db59a44f6b?w=500',
    rating: 4.4,
    reviews: 489,
    description: '9-inch chino shorts with stretch waistband for all-day wear.',
    sizes: ['30', '32', '34', '36', '38'],
    colors: [{ name: 'Khaki', hex: '#C2B280' }, { name: 'Navy', hex: '#1A303B' }],
    inStock: true,
  },
  {
    id: '10',
    name: 'Forge Fleece Hoodie',
    brand: 'Peakline',
    category: 'Men',
    categories: ['Men', 'Activewear'],
    subcategory: 'Knits',
    subcategories: ['Knits', 'Active'],
    price: 68,
    image: 'https://images.unsplash.com/photo-1556821840-3a63f95609a7?w=500',
    rating: 4.8,
    reviews: 1602,
    description: 'Brushed fleece hoodie with a structured hood and kangaroo pocket.',
    sizes: ['S', 'M', 'L', 'XL', 'XXL'],
    colors: [{ name: 'Heather', hex: '#9E9E9E' }, { name: 'Ink', hex: '#12141A' }],
    inStock: true,
    badge: 'BEST SELLER',
  },
  {
    id: 'm6',
    name: 'Merino Field Crew',
    brand: 'Harbor Knit',
    category: 'Men',
    categories: ['Men'],
    subcategory: 'Knits',
    subcategories: ['Knits'],
    price: 110,
    salePrice: 88,
    image: 'https://images.unsplash.com/photo-1620799140408-edc6dcb6d633?w=500',
    rating: 4.6,
    reviews: 334,
    description: 'Fine-gauge merino crew for office or weekend.',
    sizes: ['S', 'M', 'L', 'XL', 'XXL'],
    colors: [{ name: 'Navy', hex: '#1A303B' }, { name: 'Slate', hex: '#6B7A82' }],
    inStock: true,
    badge: 'SALE',
  },
  {
    id: 'm7',
    name: 'Atlas Pique Polo',
    brand: 'My Fashion Deals',
    category: 'Men',
    categories: ['Men'],
    subcategory: 'Shirts',
    subcategories: ['Shirts'],
    price: 58,
    image: 'https://images.unsplash.com/photo-1503341504253-dff4815485f1?w=500',
    rating: 4.5,
    reviews: 612,
    description: 'Breathable pique polo with mother-of-pearl buttons.',
    sizes: ['S', 'M', 'L', 'XL', 'XXL'],
    colors: [{ name: 'White', hex: '#FFFFFF' }, { name: 'Ink', hex: '#12141A' }],
    inStock: true,
  },
  {
    id: 'm8',
    name: 'Heritage Court Sneakers',
    brand: 'Peakline',
    category: 'Men',
    categories: ['Men', 'Shoes'],
    subcategory: 'Everyday',
    subcategories: ['Everyday', 'Runners'],
    price: 128,
    image: 'https://images.unsplash.com/photo-1542291026-7eec264c27ff?w=500',
    rating: 4.8,
    reviews: 1890,
    description: 'Leather court sneakers with gum sole and cushioned footbed.',
    sizes: ['7', '8', '9', '10', '11', '12'],
    colors: [{ name: 'White / Navy', hex: '#ECEFF1' }],
    inStock: true,
    badge: 'BEST SELLER',
  },
  {
    id: 'm9',
    name: 'Rainline Shell Jacket',
    brand: 'Peakline',
    category: 'Men',
    categories: ['Men', 'Activewear'],
    subcategory: 'Outerwear',
    subcategories: ['Outerwear', 'Active'],
    price: 165,
    image: 'https://images.unsplash.com/photo-1618220179428-22790b461013?w=500',
    rating: 4.7,
    reviews: 521,
    description: 'Waterproof shell with taped seams and packable hood.',
    sizes: ['S', 'M', 'L', 'XL', 'XXL'],
    colors: [{ name: 'Ink', hex: '#12141A' }, { name: 'Olive', hex: '#4A5C3A' }],
    inStock: true,
    badge: 'NEW',
  },
  {
    id: 'm10',
    name: 'Taper Work Denim',
    brand: 'Loomline',
    category: 'Men',
    categories: ['Men'],
    subcategory: 'Denim',
    subcategories: ['Denim'],
    price: 98,
    image: 'https://images.unsplash.com/photo-1631679706909-1844bbd07221?w=500',
    rating: 4.6,
    reviews: 778,
    description: 'Heavyweight taper jeans with reinforced seams.',
    sizes: ['28', '30', '32', '34', '36', '38'],
    colors: [{ name: 'Medium Wash', hex: '#4A5F8A' }, { name: 'Black', hex: '#111111' }],
    inStock: true,
  },
  {
    id: 'm11',
    name: 'Linen Camp Shirt',
    brand: 'My Fashion Deals',
    category: 'Men',
    categories: ['Men'],
    subcategory: 'Shirts',
    subcategories: ['Shirts'],
    price: 78,
    image: 'https://images.unsplash.com/photo-1596755094514-f87e34085b2c?w=500',
    rating: 4.5,
    reviews: 289,
    description: 'Relaxed linen camp collar — warm-weather essential.',
    sizes: ['S', 'M', 'L', 'XL', 'XXL'],
    colors: [{ name: 'Natural', hex: '#EDE6D9' }, { name: 'Sage', hex: '#8FAE8B' }],
    inStock: true,
    badge: 'NEW',
  },
  {
    id: 'm12',
    name: 'Tech Joggers',
    brand: 'Peakline',
    category: 'Men',
    categories: ['Men', 'Activewear'],
    subcategory: 'Active',
    subcategories: ['Active', 'Pants'],
    price: 72,
    salePrice: 58,
    image: 'https://images.unsplash.com/photo-1552902865-b72c031ac5ea?w=500',
    rating: 4.7,
    reviews: 934,
    description: 'Tapered tech joggers with zip pockets and stretch cuffs.',
    sizes: ['S', 'M', 'L', 'XL', 'XXL'],
    colors: [{ name: 'Black', hex: '#12141A' }, { name: 'Gray', hex: '#6B7280' }],
    inStock: true,
    badge: 'SALE',
  },
  {
    id: 'm13',
    name: 'Leather Belt',
    brand: 'Loomline',
    category: 'Men',
    categories: ['Men', 'Accessories'],
    subcategory: 'Accessories',
    subcategories: ['Accessories'],
    price: 48,
    image: 'https://images.unsplash.com/photo-1624222247344-550fb60583fd?w=500',
    rating: 4.4,
    reviews: 267,
    description: 'Full-grain leather belt with brushed steel buckle.',
    sizes: ['30', '32', '34', '36', '38'],
    colors: [{ name: 'Black', hex: '#12141A' }, { name: 'Brown', hex: '#5D4037' }],
    inStock: true,
  },
  {
    id: 'm14',
    name: 'Wool Overshirt',
    brand: 'Harbor Knit',
    category: 'Men',
    categories: ['Men'],
    subcategory: 'Outerwear',
    subcategories: ['Outerwear', 'Shirts'],
    price: 145,
    image: 'https://images.unsplash.com/photo-1617137968427-85924c800a22?w=500',
    rating: 4.6,
    reviews: 356,
    description: 'Heavyweight wool-blend overshirt — jacket or layer.',
    sizes: ['S', 'M', 'L', 'XL', 'XXL'],
    colors: [{ name: 'Olive', hex: '#4A5C3A' }, { name: 'Charcoal', hex: '#374151' }],
    inStock: true,
  },
  {
    id: 'm15',
    name: 'Trail Grip Hikers',
    brand: 'Peakline',
    category: 'Men',
    categories: ['Men', 'Shoes', 'Activewear'],
    subcategory: 'Boots',
    subcategories: ['Boots', 'Runners'],
    price: 135,
    image: 'https://images.unsplash.com/photo-1525966222134-fcfa99b8ae77?w=500',
    rating: 4.7,
    reviews: 512,
    description: 'Aggressive lug outsole with breathable waterproof membrane.',
    sizes: ['7', '8', '9', '10', '11', '12'],
    colors: [{ name: 'Ink / Lime', hex: '#37474F' }],
    inStock: true,
    badge: 'NEW',
  },
  {
    id: 'm16',
    name: 'Slim Leather Wallet',
    brand: 'Loomline',
    category: 'Men',
    categories: ['Men', 'Handbags', 'Accessories'],
    subcategory: 'Wallets',
    subcategories: ['Wallets'],
    price: 68,
    image: 'https://images.unsplash.com/photo-1627123424574-724758594e93?w=500',
    rating: 4.6,
    reviews: 445,
    description: 'RFID-blocking bifold with eight card slots.',
    sizes: ['One Size'],
    colors: [{ name: 'Black', hex: '#12141A' }, { name: 'Tan', hex: '#C4A484' }],
    inStock: true,
  },
  {
    id: 'm17',
    name: 'Performance Tee 3-Pack',
    brand: 'Peakline',
    category: 'Men',
    categories: ['Men', 'Activewear'],
    subcategory: 'Active',
    subcategories: ['Active', 'Shirts'],
    price: 54,
    image: 'https://images.unsplash.com/photo-1521572163474-6864f9cf17ab?w=500',
    rating: 4.8,
    reviews: 1201,
    description: 'Moisture-wicking crew tees in a ready-to-wear pack.',
    sizes: ['S', 'M', 'L', 'XL', 'XXL'],
    colors: [{ name: 'Assorted', hex: '#9E9E9E' }],
    inStock: true,
    badge: 'BEST SELLER',
  },
  {
    id: 'm18',
    name: 'Structured Blazer',
    brand: 'My Fashion Deals',
    category: 'Men',
    categories: ['Men'],
    subcategory: 'Outerwear',
    subcategories: ['Outerwear'],
    price: 198,
    salePrice: 168,
    image: 'https://images.unsplash.com/photo-1507679799987-c73779587ccf?w=500',
    rating: 4.7,
    reviews: 278,
    description: 'Unstructured blazer with patch pockets — smart casual staple.',
    sizes: ['S', 'M', 'L', 'XL', 'XXL'],
    colors: [{ name: 'Navy', hex: '#1A303B' }, { name: 'Gray', hex: '#6B7280' }],
    inStock: true,
    badge: 'SALE',
  },
  {
    id: 'm19',
    name: 'Steel Signet Ring',
    brand: 'My Fashion Deals',
    category: 'Men',
    categories: ['Men', 'Jewelry', 'Accessories'],
    subcategory: 'Rings',
    subcategories: ['Rings'],
    price: 78,
    image: 'https://images.unsplash.com/photo-1605100804763-247f67b3557e?w=500',
    rating: 4.4,
    reviews: 189,
    description: 'Brushed stainless signet with a solid weight.',
    sizes: ['9', '10', '11', '12'],
    colors: [{ name: 'Steel', hex: '#90A4AE' }],
    inStock: true,
  },
  {
    id: 'm20',
    name: 'Weekender Duffel',
    brand: 'Peakline',
    category: 'Men',
    categories: ['Men', 'Handbags', 'Accessories'],
    subcategory: 'Weekenders',
    subcategories: ['Weekenders'],
    price: 118,
    image: 'https://images.unsplash.com/photo-1553062407-98eeb64c6a62?w=500',
    rating: 4.6,
    reviews: 367,
    description: 'Rugged canvas weekender with shoe compartment.',
    sizes: ['One Size'],
    colors: [{ name: 'Olive', hex: '#4A5C3A' }, { name: 'Black', hex: '#12141A' }],
    inStock: true,
    badge: 'NEW',
  },

  // ── Kids ──────────────────────────────────────────────────────
  {
    id: '11',
    name: 'Little Peak Graphic Hoodie',
    brand: 'Peakline',
    category: 'Kids',
    categories: ['Kids'],
    subcategory: 'Boys',
    subcategories: ['Boys', 'Girls'],
    price: 42,
    image: 'https://images.unsplash.com/photo-1503454537195-1dcabb73ffb9?w=500',
    rating: 4.8,
    reviews: 290,
    description: 'Soft cotton blend hoodie with a mountain graphic.',
    sizes: ['4', '5', '6', '7', '8', '10', '12'],
    colors: [{ name: 'Gray', hex: '#9E9E9E' }, { name: 'Lime', hex: '#D4F34A' }],
    inStock: true,
    badge: 'NEW',
  },
  {
    id: '12',
    name: 'Celebration Tulle Dress',
    brand: 'My Fashion Deals',
    category: 'Kids',
    categories: ['Kids'],
    subcategory: 'Girls',
    subcategories: ['Girls'],
    price: 58,
    salePrice: 42,
    image: 'https://images.unsplash.com/photo-1518831959646-742c3a14ebf7?w=500',
    rating: 4.7,
    reviews: 201,
    description: 'Layered tulle dress for birthdays and photos.',
    sizes: ['4', '5', '6', '7', '8', '10'],
    colors: [{ name: 'Blush', hex: '#E8C4B8' }],
    inStock: true,
    badge: 'SALE',
  },
  {
    id: '13',
    name: 'Explorer Cargo Joggers',
    brand: 'Loomline',
    category: 'Kids',
    categories: ['Kids'],
    subcategory: 'Boys',
    subcategories: ['Boys'],
    price: 38,
    image: 'https://images.unsplash.com/photo-1519238263530-99bdd11df2ea?w=500',
    rating: 4.5,
    reviews: 167,
    description: 'Durable joggers with cargo pockets and elastic cuffs.',
    sizes: ['4', '5', '6', '7', '8', '10', '12', '14'],
    colors: [{ name: 'Olive', hex: '#556B2F' }, { name: 'Ink', hex: '#12141A' }],
    inStock: true,
  },
  {
    id: '14',
    name: 'Glow Trail Sneakers',
    brand: 'Peakline',
    category: 'Kids',
    categories: ['Kids', 'Shoes'],
    subcategory: 'Shoes',
    subcategories: ['Shoes'],
    price: 54,
    image: 'https://images.unsplash.com/photo-1579586337278-3befd40fd17a?w=500',
    rating: 4.6,
    reviews: 612,
    description: 'Light-up outsoles with easy hook-and-loop straps.',
    sizes: ['11', '12', '13', '1', '2', '3'],
    colors: [{ name: 'Blue / Lime', hex: '#1565c0' }],
    inStock: true,
    badge: 'NEW',
  },
  {
    id: '15',
    name: 'First Days Bodysuit Set',
    brand: 'Harbor Knit',
    category: 'Kids',
    categories: ['Kids'],
    subcategory: 'Baby',
    subcategories: ['Baby'],
    price: 36,
    image: 'https://images.unsplash.com/photo-1522771739844-6a9f6d5f14af?w=500',
    rating: 4.9,
    reviews: 980,
    description: 'Five-piece organic cotton bodysuit set.',
    sizes: ['0-3M', '3-6M', '6-9M', '9-12M'],
    colors: [{ name: 'Assorted', hex: '#ECEFF1' }],
    inStock: true,
    badge: 'BEST SELLER',
  },
  {
    id: 'k6',
    name: 'Build Lab Brick Kit',
    brand: 'My Fashion Deals',
    category: 'Kids',
    categories: ['Kids'],
    subcategory: 'Play',
    subcategories: ['Play'],
    price: 34,
    salePrice: 27,
    image: 'https://images.unsplash.com/photo-1566576912321-d58ddd7a6088?w=500',
    rating: 4.9,
    reviews: 889,
    description: 'Open-ended brick set with a lid that doubles as a build base.',
    sizes: ['One Size'],
    colors: [{ name: 'Multi', hex: '#D4F34A' }],
    inStock: true,
    badge: 'SALE',
  },

  // ── Home ──────────────────────────────────────────────────────
  {
    id: '16',
    name: 'Cloudline Sheet Set',
    brand: 'Harbor Knit',
    category: 'Home',
    categories: ['Home'],
    subcategory: 'Bedding',
    subcategories: ['Bedding'],
    price: 148,
    salePrice: 118,
    image: 'https://images.unsplash.com/photo-1631049307264-da0ec9d70304?w=500',
    rating: 4.7,
    reviews: 1456,
    description: '400-thread cotton percale that stays cool all night.',
    sizes: ['Twin', 'Full', 'Queen', 'King'],
    colors: [{ name: 'White', hex: '#FFFFFF' }],
    inStock: true,
    badge: 'SALE',
  },
  {
    id: '17',
    name: 'Forge Dutch Oven',
    brand: 'Loomline',
    category: 'Home',
    categories: ['Home'],
    subcategory: 'Kitchen',
    subcategories: ['Kitchen'],
    price: 160,
    image: 'https://images.unsplash.com/photo-1556911220-bff31c812dba?w=500',
    rating: 4.8,
    reviews: 622,
    description: 'Enameled cast iron 5.5-qt Dutch oven.',
    sizes: ['One Size'],
    colors: [{ name: 'Ink', hex: '#12141A' }, { name: 'Lime', hex: '#D4F34A' }],
    inStock: true,
    badge: 'NEW',
  },
  {
    id: '18',
    name: 'Velvet Throw Pillows',
    brand: 'Solace',
    category: 'Home',
    categories: ['Home'],
    subcategory: 'Decor',
    subcategories: ['Decor'],
    price: 58,
    image: 'https://images.unsplash.com/photo-1629949009765-40fc74c9ec21?w=500',
    rating: 4.4,
    reviews: 301,
    description: 'Plush velvet covers with feather-down inserts (pair).',
    sizes: ['18x18', '20x20'],
    colors: [{ name: 'Forest', hex: '#2E5A3C' }, { name: 'Lime', hex: '#D4F34A' }],
    inStock: true,
  },
  {
    id: '19',
    name: 'Waffle Bath Bundle',
    brand: 'Harbor Knit',
    category: 'Home',
    categories: ['Home'],
    subcategory: 'Bath',
    subcategories: ['Bath'],
    price: 88,
    salePrice: 68,
    image: 'https://images.unsplash.com/photo-1616486338812-3dadae4b4ace?w=500',
    rating: 4.7,
    reviews: 489,
    description: 'Six-piece waffle weave set that dries fast.',
    sizes: ['Bath', 'Hand', 'Wash'],
    colors: [{ name: 'Stone', hex: '#E8E4DC' }],
    inStock: true,
    badge: 'SALE',
  },
  {
    id: '20',
    name: 'Arc Ceramic Lamp',
    brand: 'Loomline',
    category: 'Home',
    categories: ['Home'],
    subcategory: 'Furniture',
    subcategories: ['Furniture', 'Decor'],
    price: 96,
    image: 'https://images.unsplash.com/photo-1507473885765-e6ed057f782c?w=500',
    rating: 4.5,
    reviews: 267,
    description: 'Matte ceramic base with linen drum shade.',
    sizes: ['One Size'],
    colors: [{ name: 'Bone', hex: '#F5F1E8' }, { name: 'Ink', hex: '#12141A' }],
    inStock: true,
  },
  {
    id: 'h6',
    name: 'Field Notes Candle Trio',
    brand: 'My Fashion Deals',
    category: 'Home',
    categories: ['Home', 'Accessories'],
    subcategory: 'Decor',
    subcategories: ['Decor'],
    price: 48,
    image: 'https://images.unsplash.com/photo-1513506003901-1e6a229e2d15?w=500',
    rating: 4.6,
    reviews: 701,
    description: 'Three soy candles: cedar, coastal salt, citrus leaf.',
    sizes: ['One Size'],
    colors: [{ name: 'Assorted', hex: '#D4F34A' }],
    inStock: true,
    badge: 'NEW',
  },

  // ── Shoes ─────────────────────────────────────────────────────
  {
    id: '21',
    name: 'Velocity Air Runners',
    brand: 'Peakline',
    category: 'Shoes',
    categories: ['Shoes', 'Activewear', 'Men', 'Women'],
    subcategory: 'Runners',
    subcategories: ['Runners'],
    price: 145,
    image: 'https://images.unsplash.com/photo-1606107557195-0e29a4b5b4aa?w=500',
    rating: 4.9,
    reviews: 2801,
    description: 'Responsive cushioning for daily miles — unisex fit.',
    sizes: ['6', '7', '8', '9', '10', '11', '12'],
    colors: [{ name: 'Ink / Lime', hex: '#12141A' }],
    inStock: true,
    badge: 'BEST SELLER',
  },
  {
    id: '22',
    name: 'Boardroom Oxfords',
    brand: 'Loomline',
    category: 'Shoes',
    categories: ['Shoes', 'Men'],
    subcategory: 'Everyday',
    subcategories: ['Everyday'],
    price: 178,
    salePrice: 148,
    image: 'https://images.unsplash.com/photo-1614252235316-8c857d38b5f4?w=500',
    rating: 4.7,
    reviews: 356,
    description: 'Full-grain leather oxfords with cushioned footbed.',
    sizes: ['7', '8', '9', '10', '11', '12'],
    colors: [{ name: 'Black', hex: '#111111' }],
    inStock: true,
    badge: 'SALE',
  },
  {
    id: '23',
    name: 'Slip Canvas Dailies',
    brand: 'My Fashion Deals',
    category: 'Shoes',
    categories: ['Shoes', 'Men', 'Women'],
    subcategory: 'Everyday',
    subcategories: ['Everyday'],
    price: 58,
    image: 'https://images.unsplash.com/photo-1460353581641-37baddab0fa2?w=500',
    rating: 4.6,
    reviews: 1402,
    description: 'No-tie canvas slip-ons with a grippy rubber sole.',
    sizes: ['6', '7', '8', '9', '10', '11'],
    colors: [{ name: 'Ink', hex: '#12141A' }, { name: 'White', hex: '#FFFFFF' }],
    inStock: true,
  },
  {
    id: '24',
    name: 'Cloud Slide Sandals',
    brand: 'Peakline',
    category: 'Shoes',
    categories: ['Shoes', 'Activewear'],
    subcategory: 'Sandals',
    subcategories: ['Sandals'],
    price: 38,
    image: 'https://images.unsplash.com/photo-1605348532760-6753d2c43329?w=500',
    rating: 4.5,
    reviews: 2100,
    description: 'Contoured foam slides for recovery and weekends.',
    sizes: ['6', '7', '8', '9', '10', '11'],
    colors: [{ name: 'Ink', hex: '#12141A' }, { name: 'Lime', hex: '#D4F34A' }],
    inStock: true,
  },

  // ── Handbags ──────────────────────────────────────────────────
  {
    id: '26',
    name: 'Studio Leather Tote',
    brand: 'Loomline',
    category: 'Handbags',
    categories: ['Handbags', 'Women', 'Accessories'],
    subcategory: 'Totes',
    subcategories: ['Totes'],
    price: 248,
    salePrice: 198,
    image: 'https://images.unsplash.com/photo-1584917865442-de89df76afd3?w=500',
    rating: 4.8,
    reviews: 401,
    description: 'Roomy structured tote with zip top and laptop sleeve.',
    sizes: ['One Size'],
    colors: [{ name: 'Saddle', hex: '#8B5E3C' }, { name: 'Ink', hex: '#12141A' }],
    inStock: true,
    badge: 'SALE',
  },
  {
    id: '27',
    name: 'Mini Backpack Purse',
    brand: 'Peakline',
    category: 'Handbags',
    categories: ['Handbags', 'Women', 'Accessories'],
    subcategory: 'Crossbody',
    subcategories: ['Crossbody'],
    price: 82,
    image: 'https://images.unsplash.com/photo-1553062407-98eeb64c6a62?w=500',
    rating: 4.6,
    reviews: 489,
    description: 'Convertible mini backpack with top handle.',
    sizes: ['One Size'],
    colors: [{ name: 'Black', hex: '#12141A' }, { name: 'Lime', hex: '#D4F34A' }],
    inStock: true,
    badge: 'NEW',
  },

  // ── Jewelry ───────────────────────────────────────────────────
  {
    id: '31',
    name: 'North Star Pendant',
    brand: 'My Fashion Deals',
    category: 'Jewelry',
    categories: ['Jewelry', 'Women', 'Accessories'],
    subcategory: 'Necklaces',
    subcategories: ['Necklaces'],
    price: 98,
    salePrice: 78,
    image: 'https://images.unsplash.com/photo-1515562141207-7a88fb7ce338?w=500',
    rating: 4.8,
    reviews: 401,
    description: 'Minimal pendant on a fine chain.',
    sizes: ['One Size'],
    colors: [{ name: 'Silver', hex: '#E8E8E8' }],
    inStock: true,
    badge: 'SALE',
  },
  {
    id: '32',
    name: 'Transit Steel Watch',
    brand: 'Peakline',
    category: 'Jewelry',
    categories: ['Jewelry', 'Men', 'Women', 'Accessories'],
    subcategory: 'Watches',
    subcategories: ['Watches'],
    price: 198,
    image: 'https://images.unsplash.com/photo-1615729947596-a598e5de0ab3?w=500',
    rating: 4.7,
    reviews: 412,
    description: 'Slim steel watch with sapphire crystal — unisex.',
    sizes: ['One Size'],
    colors: [{ name: 'Silver', hex: '#CFD8DC' }],
    inStock: true,
    badge: 'NEW',
  },

  // ── Beauty ────────────────────────────────────────────────────
  {
    id: '36',
    name: 'Dawn Vitamin C Serum',
    brand: 'My Fashion Deals',
    category: 'Beauty',
    categories: ['Beauty'],
    subcategory: 'Skincare',
    subcategories: ['Skincare'],
    price: 48,
    image: 'https://images.unsplash.com/photo-1620916566398-39f1143ab7be?w=500',
    rating: 4.6,
    reviews: 1234,
    description: 'Stabilized vitamin C for brighter-looking skin.',
    sizes: ['30ml', '50ml'],
    colors: [],
    inStock: true,
    badge: 'NEW',
  },
  {
    id: '37',
    name: 'Velvet Matte Lip',
    brand: 'Solace',
    category: 'Beauty',
    categories: ['Beauty'],
    subcategory: 'Makeup',
    subcategories: ['Makeup'],
    price: 24,
    image: 'https://images.unsplash.com/photo-1586495777744-4413f21062fa?w=500',
    rating: 4.8,
    reviews: 3102,
    description: 'Creamy matte lipstick that stays put.',
    sizes: ['One Size'],
    colors: [{ name: 'Berry', hex: '#8B1E3F' }, { name: 'Nude', hex: '#C45C3A' }],
    inStock: true,
    badge: 'BEST SELLER',
  },
  {
    id: '38',
    name: 'Cedar Sea Cologne',
    brand: 'My Fashion Deals',
    category: 'Beauty',
    categories: ['Beauty', 'Accessories'],
    subcategory: 'Fragrance',
    subcategories: ['Fragrance'],
    price: 92,
    image: 'https://images.unsplash.com/photo-1541643600914-78b084683601?w=500',
    rating: 4.7,
    reviews: 801,
    description: 'Mineral, woody cologne in a refillable bottle.',
    sizes: ['30ml', '100ml'],
    colors: [],
    inStock: true,
  },
  {
    id: '39',
    name: 'Bond Repair Hair Masque',
    brand: 'Peakline',
    category: 'Beauty',
    categories: ['Beauty'],
    subcategory: 'Hair',
    subcategories: ['Hair'],
    price: 34,
    image: 'https://images.unsplash.com/photo-1522338242992-e1a54906a8da?w=500',
    rating: 4.8,
    reviews: 1990,
    description: 'Weekly treatment that reduces breakage.',
    sizes: ['100ml'],
    colors: [],
    inStock: true,
    badge: 'BEST SELLER',
  },

  // ── Activewear extras ─────────────────────────────────────────
  {
    id: 'a1',
    name: 'Pulse Training Shorts',
    brand: 'Peakline',
    category: 'Activewear',
    categories: ['Activewear', 'Men'],
    subcategory: 'Active',
    subcategories: ['Active'],
    price: 48,
    image: 'https://images.unsplash.com/photo-1517836357463-d25dfeac3438?w=500',
    rating: 4.6,
    reviews: 678,
    description: 'Lightweight training shorts with liner and zip pocket.',
    sizes: ['S', 'M', 'L', 'XL', 'XXL'],
    colors: [{ name: 'Black', hex: '#12141A' }, { name: 'Lime', hex: '#D4F34A' }],
    inStock: true,
    badge: 'NEW',
  },
  {
    id: 'a2',
    name: 'Flow Sports Bra',
    brand: 'Peakline',
    category: 'Activewear',
    categories: ['Activewear', 'Women'],
    subcategory: 'Activewear',
    subcategories: ['Activewear', 'Active'],
    price: 42,
    image: 'https://images.unsplash.com/photo-1518611012118-696072aa579a?w=500',
    rating: 4.7,
    reviews: 912,
    description: 'Medium-support sports bra with soft straps.',
    sizes: ['XS', 'S', 'M', 'L', 'XL'],
    colors: [{ name: 'Black', hex: '#12141A' }, { name: 'Fog', hex: '#9AA8B0' }],
    inStock: true,
  },
  {
    id: 'a3',
    name: 'Recovery Zip Hoodie',
    brand: 'Peakline',
    category: 'Activewear',
    categories: ['Activewear', 'Men', 'Women'],
    subcategory: 'Active',
    subcategories: ['Active', 'Knits'],
    price: 78,
    salePrice: 64,
    image: 'https://images.unsplash.com/photo-1556821840-3a63f95609a7?w=500',
    rating: 4.5,
    reviews: 445,
    description: 'Unisex recovery hoodie with full zip and thumbholes.',
    sizes: ['XS', 'S', 'M', 'L', 'XL', 'XXL'],
    colors: [{ name: 'Heather', hex: '#9E9E9E' }, { name: 'Ink', hex: '#12141A' }],
    inStock: true,
    badge: 'SALE',
  },

  // ── Accessories extras ────────────────────────────────────────
  {
    id: 'x1',
    name: 'Vista Cap',
    brand: 'My Fashion Deals',
    category: 'Accessories',
    categories: ['Accessories', 'Men', 'Women'],
    subcategory: 'Accessories',
    subcategories: ['Accessories'],
    price: 32,
    image: 'https://images.unsplash.com/photo-1588850561407-ed78c63e2248?w=500',
    rating: 4.5,
    reviews: 534,
    description: 'Structured cotton cap with embroidered mark.',
    sizes: ['One Size'],
    colors: [{ name: 'Black', hex: '#12141A' }, { name: 'Lime', hex: '#D4F34A' }],
    inStock: true,
    badge: 'NEW',
  },
  {
    id: 'x2',
    name: 'Recycled Nylon Belt Bag',
    brand: 'Peakline',
    category: 'Accessories',
    categories: ['Accessories', 'Handbags', 'Activewear'],
    subcategory: 'Crossbody',
    subcategories: ['Crossbody'],
    price: 48,
    image: 'https://images.unsplash.com/photo-1553062407-98eeb64c6a62?w=500',
    rating: 4.6,
    reviews: 389,
    description: 'Packable belt bag for travel days and festivals.',
    sizes: ['One Size'],
    colors: [{ name: 'Ink', hex: '#12141A' }, { name: 'Olive', hex: '#4A5C3A' }],
    inStock: true,
  },
];

export const categories = [
  { id: 'women', name: 'Women', image: 'https://images.unsplash.com/photo-1483985988355-763728e1935b?w=500', count: 520 },
  { id: 'men', name: 'Men', image: 'https://images.unsplash.com/photo-1490578474895-699cd4e2cf59?w=500', count: 480 },
  { id: 'kids', name: 'Kids', image: 'https://images.unsplash.com/photo-1503919545889-aef636e10ad4?w=500', count: 210 },
  { id: 'home', name: 'Home', image: 'https://images.unsplash.com/photo-1484101403633-562f891dc89a?w=500', count: 340 },
  { id: 'shoes', name: 'Shoes', image: 'https://images.unsplash.com/photo-1460353581641-37baddab0fa2?w=500', count: 290 },
  { id: 'handbags', name: 'Bags', image: 'https://images.unsplash.com/photo-1584917865442-de89df76afd3?w=500', count: 160 },
  { id: 'jewelry', name: 'Jewelry', image: 'https://images.unsplash.com/photo-1515562141207-7a88fb7ce338?w=500', count: 180 },
  { id: 'beauty', name: 'Beauty', image: 'https://images.unsplash.com/photo-1596462502278-27bfdc403348?w=500', count: 220 },
  { id: 'activewear', name: 'Activewear', image: 'https://images.unsplash.com/photo-1517836357463-d25dfeac3438?w=500', count: 260 },
  { id: 'accessories', name: 'Accessories', image: 'https://images.unsplash.com/photo-1588850561407-ed78c63e2248?w=500', count: 190 },
];

export const navCategories = [
  { id: 'women', name: 'Women', subcategories: ['Dresses', 'Tops', 'Pants', 'Outerwear', 'Knits', 'Activewear'] },
  { id: 'men', name: 'Men', subcategories: ['Shirts', 'Denim', 'Outerwear', 'Knits', 'Active', 'Accessories'] },
  { id: 'kids', name: 'Kids', subcategories: ['Girls', 'Boys', 'Baby', 'Shoes', 'Play'] },
  { id: 'home', name: 'Home', subcategories: ['Bedding', 'Bath', 'Kitchen', 'Furniture', 'Decor'] },
  { id: 'shoes', name: 'Shoes', subcategories: ['Runners', 'Boots', 'Sandals', 'Everyday'] },
  { id: 'handbags', name: 'Bags', subcategories: ['Totes', 'Crossbody', 'Weekenders', 'Wallets'] },
  { id: 'jewelry', name: 'Jewelry', subcategories: ['Necklaces', 'Earrings', 'Bracelets', 'Watches', 'Rings'] },
  { id: 'beauty', name: 'Beauty', subcategories: ['Skincare', 'Makeup', 'Fragrance', 'Hair'] },
  { id: 'activewear', name: 'Active', subcategories: ['Active', 'Activewear', 'Runners'] },
  { id: 'accessories', name: 'Accessories', subcategories: ['Accessories', 'Totes', 'Crossbody'] },
];
